import { GetStaticPaths, GetStaticProps, NextPage } from 'next';

import { TemplateCentralDeAjudaInterna } from '@/templates/central-de-ajuda-interna';
import {
  CentralDeAjudaDataItem,
  centralDeAjudaPagesData,
} from '@/templates/central-de-ajuda/data/index';

interface CentralDeAjudaInternaProps {
  pageData: CentralDeAjudaDataItem;
}

const CentralDeAjudaInterna: NextPage<CentralDeAjudaInternaProps> = ({
  pageData,
}) => {
  return <TemplateCentralDeAjudaInterna pageData={pageData} />;
};

export default CentralDeAjudaInterna;

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const pageId = params?.pageId;

  const pageData: CentralDeAjudaDataItem | undefined =
    centralDeAjudaPagesData[String(pageId)];

  if (!pageData) {
    return {
      notFound: true,
      revalidate: 10,
    };
  }

  return {
    props: {
      pageData,
    },
  };
};
